import { Spinner } from 'react-bootstrap'

const Loading = (props: { className?: any }) => {
  return (
    <div className={`w-100 centered p-4 ${props.className}`}>
      <Spinner animation="border" role="status" variant="primary" >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  )
}

export default Loading